import * as React from 'react';
import { Fragment } from 'react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { Spinner } from '@kurtosys/ksys-portal-components/build/components/UI/Spinner.js';
import Translate from './Translate';

interface LoadMoreButton {
    theme: { [key: string]: { prop: any } };
    onClick: Function;
    disabled: boolean;
    isLoading: boolean;
}

const Button = styled<any, any>('button') `
    ${propStyles};
    outline: none;
    cursor: pointer;
    opacity: ${p => p.disabled ? 0.5 : 1};
`;

Button.defaultProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    paddingX: "md",
    paddingY: "sm",
    marginY: "md",
    height: "40px",
    minHeight: "40px",
    minWidth: "30%",
    fontSize: "inherit",
    fontFamily: "heading",
    fontWeight: "medium",
    textTransform: "uppercase",
    borderRadius: "sm",
    borderStyle: "none",
    boxShadow: "sm",
    textAlign: "center",
    color: "white",
    bgColor: "primary"
};

const LoadMoreButton: React.SFC<LoadMoreButton> = ({ theme, onClick, disabled, isLoading, ...props }) => (
    <Button
        onClick={onClick}
        disabled={disabled}
        {...props}
        {...theme.MoreButton}
    >
        { 
            isLoading ? (
                <Fragment>
                    <Spinner iconSize="16px" marginX="sm" />
                    <Translate>Loading</Translate>
                </Fragment>
            )
            : (
                <Translate>Load More</Translate>
            )
        }
    </Button>
);

export default withTheme(LoadMoreButton);


// WEBPACK FOOTER //
// ./src/Components/LoadMoreButton.tsx